export default "__VITE_ASSET__CsePIouE__"